import * as React from 'react';
import './index.scss';

export default function Index ( props: { product: any; seller: any; } ) {
    const { product,seller } = props;
    const { productIsMarketGoods,sku,price } = product;
    if ( productIsMarketGoods || price?.productLadderPrices?.length > 0 && sku?.skuAttrs?.length > 0 || seller.sellerSelfOperated ) {
        return null
    }
    return (
        <div id="product-glp" />
    )
}
